import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blog redone",
  "description": "",
  "published": "2008-10-05T00:00:00.000Z",
  "redirect_from": ["/blog/blog-redone/swizec/62"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is in fact a test post to see if I can post now that everything has been turned upside down and renewed and such. The RSS is what troubles me mainly.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      